import { useLocation, useNavigate } from 'react-router';
import Account from "pages/Account";

export default function AccountPage() {
  const navigate = useNavigate();
  const location = useLocation();

  return <Account location={location} navigate={navigate}/>;
}
